module.exports = __webpack_public_path__ + "static/fonts/gt-america-standard-medium.28b645e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/gt-america-standard-medium.woff2
// module id = 1190
// module chunks = 0